/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {
    import fld = ServiceOutwardDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ServiceOutwardDetailsEditor extends _Ext.GridEditorBase<ServiceOutwardDetailsRow> {
        protected getColumnsKey() { return "Finance.ServiceOutwardDetails"; }
        protected getDialogType() { return ServiceOutwardDetailsDialog; }
        protected getLocalTextPrefix() { return ServiceOutwardDetailsRow.localTextPrefix; }
        private pendingChanges: Q.Dictionary<any> = {};


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ServiceOutwardDialog).calculateTotals();
                }
            })

        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Amount).format = amt;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        //#region  ItemGrid Inline Editor

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Amount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }

            // *** Calculate Wastage ***
            if (field === fld.Amount && value >= 0) {
                item[field] = value;
            }
            this.view.updateItem(id, item);
            this.view.refresh();

            (this.parentDialog as ServiceOutwardDialog).calculateTotals();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            if (input.hasClass('weight'))
                value = Q.formatNumber(value, '0.000');

            if (input.hasClass('amount'))
                value = q.formatAmount(value);

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.push({
                title: "Add Service",
                cssClass: "add-button",
                onClick: () => {

                    var grid = Common.ServicesSelectGrid;

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        Width: 400, 
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.ServicesMasterRow[]) => {
                        //let filteredLabor: any[];
                        //var self = this;

                        var ServiceDetails= [];
                        for (var i = 0; i < selectedItems.length; i++) {
                            var selectedservice = selectedItems[i];
                            var newservice: ServiceOutwardDetailsRow = {
                                ServiceId: selectedservice.ServiceId,
                                ServiceCode: selectedservice.ServiceCode,
                                TaxCode: selectedservice.TaxCode,
                            }
                            ServiceDetails.push(newservice);
                        }
                         
                        for (let Detail of ServiceDetails) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}